import React, { useRef } from 'react';
import './zono-money-simulator.scss';
import { JTBD_SVGS } from '../assets';
import { CustomSwipeableDrawer } from '../campaign-jtbd-whatsapp/mobile-whatsapp-simulator/components';
// import { JTBD_PNGS } from '../assets';

interface ZonoMoneySimulatorProps {
  onClose: () => void;
  open: boolean;
  zonoMoneyUrl: string;
}

export const ZonoMoneySimulator: React.FC<ZonoMoneySimulatorProps> = ({
  onClose,
  open,
  zonoMoneyUrl,
}) => {
  const zonoMoneyRef = useRef<HTMLIFrameElement | null>(null);
  return (
    <CustomSwipeableDrawer
      open={open}
      onClose={onClose}
      maxHeight="98%"
      height="98%"
      showHandle={false}
    >
      <div className="zono-money-simulator">
        <div className="zono-money-simulator-header">
          <span className="zono-money-simulator-header-text tertiary-font-regular">
            mobile.zotok.ai
          </span>
          <img
            src={JTBD_SVGS.CloseGreyIcon}
            alt=""
            className="zono-money-simulator-header-close"
            onClick={onClose}
          />
        </div>
        <div className="zono-money-simulator-body">
          <iframe
            src={zonoMoneyUrl}
            ref={zonoMoneyRef}
            title="Zono Money App"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </div>
    </CustomSwipeableDrawer>
  );
};
